import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { useSelector } from 'react-redux';
import './style.scss';

export interface PropsType {
    show: boolean;
    content: string | JSX.Element;
    subContent?: string | JSX.Element;
    leftClick?: () => void;
    title?: string;
    rightClick: () => void;
    leftButtonTitle?: string;
    rightButtonTitle?: string;
    icon?: string;
    customClassName?: string;
    size?: 'sm' | 'lg' | 'xl';
    hideIcon?: boolean;
    onExited?: () => void;
    color?: string;
    subtitleColor?: string;
}

const ConfirmDialog = ({
    show,
    content,
    subContent,
    title,
    leftClick,
    rightClick,
    leftButtonTitle,
    rightButtonTitle,
    icon,
    customClassName = '',
    size,
    hideIcon,
    onExited,
    color,
    subtitleColor,
}: PropsType) => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);

    leftButtonTitle = leftButtonTitle ? leftButtonTitle : strings.YES;
    rightButtonTitle = rightButtonTitle ? rightButtonTitle : strings.NO;
    icon = icon ? icon : Constants.icons.ANNOUNCEMENT;
    title = title ? title : strings.ATTENTION;
    size = size ? size : 'sm';
    color = color ? color : '#f10';
    subtitleColor = subtitleColor ? subtitleColor : '#f10';

    return (
        <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className={`confirm-dialog ${customClassName}`}
            onExited={onExited}
            show={show}
            size={size}
        >
            <Modal.Body>
                <div className="modal-inner">
                    {!hideIcon && (
                        <i className="material-icons-outlined align-middle icon" style={{ color: color }}>
                            {icon}
                        </i>
                    )}
                    {title && <span className="text-title">{title}</span>}
                    <span className="text-content">{content}</span>
                    {subContent && <span style={{ color: subtitleColor }}>{subContent}</span>}
                </div>
                <div className={`modal-bottom ${leftClick ? '' : 'justify-content-center'}`}>
                    {leftClick && (
                        <button className="btn btn-secondary left-button" data-dismiss="modal" onClick={leftClick} type="button">
                            {leftButtonTitle}
                        </button>
                    )}
                    <button className="btn btn-primary right-button" data-dismiss="modal" onClick={rightClick} type="button">
                        {rightButtonTitle}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmDialog;
